// Kleine helpers rond de Gripp-basisoffertes (bron van waarheid voor de
// standaardopbouw en prijzen van de generator). Puur, zodat ze los te testen zijn.

export function euro(waarde) {
  const n = Number(waarde) || 0;
  const tekst = n.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `€${tekst.endsWith(',00') ? tekst.slice(0, -3) : tekst}`;
}

// '2026-10-23T14:05:00' → '23-10-2026 14:05' (alleenDatum: '23-10-2026').
export function formatSyncTijd(iso, alleenDatum = false) {
  if (!iso) return '';
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
  if (!m) return String(iso);
  const datum = `${m[3]}-${m[2]}-${m[1]}`;
  return alleenDatum || !m[4] ? datum : `${datum} ${m[4]}:${m[5]}`;
}

// Korte basisofferte-naam voor in een regel: zonder "(TITEL AANPASSEN!)".
export function korteBasisNaam(naam) {
  return String(naam || '').replace(/\s*\((titel aanpassen!?|onderwerp aanpassen)\)\s*/ig, ' ').trim();
}

// Herkomstregel onder een offerteregel: waar komt hij vandaan, wanneer gesynct,
// en wijkt de prijs nu af van Gripp? `actueel` = de basis-match uit de laatste
// prijscheck (actueler dan de momentopname op de regel). Null zonder basis.
export function basisHerkomst(regel, actueel = null) {
  const b = (actueel && actueel.naam) ? { ...(regel?.basis || {}), ...actueel } : (regel && regel.basis);
  if (!b || !b.naam) return null;
  const prijs = Number(regel.sellingprice);
  const gripp = Number(b.prijs);
  const afwijking = Number.isFinite(prijs) && Number.isFinite(gripp) && Math.abs(prijs - gripp) > 0.005;
  return {
    tekst: `uit basis “${korteBasisNaam(b.naam)}”${b.gesynct ? ` · gesynct ${formatSyncTijd(b.gesynct)}` : ''}`,
    code: b.code || null,
    override: b.override && !b.override.gelijk ? b.override : null,
    gecorrigeerd: b.gecorrigeerd != null ? b.gecorrigeerd : null,
    afwijking: afwijking ? { gripp, verschil: prijs - gripp } : null,
  };
}

// Velden die bij een product horen: bij een productwissel weg, anders gaan inkoop,
// verborgen, titel en de exacte eenheid van het vorige product mee naar Gripp.
export const PRODUCT_VELDEN_LEEG = {
  // hidden: false (niet null), zodat een verborgen regel bij bijwerken ook echt zichtbaar wordt.
  basis: null, code: null, buyingprice: null, hidden: false, unitId: null, titel: '', priceSource: null,
  productIdBron: null,
};
